import React, { useState } from "react";
import { Link } from "react-router-dom";

const LOGO_URL =
  "https://images.estatesit.uk/https://www.newspaceuk.com/content/images/logo.png?format=webp";

// Original New Space logo (with graphic fallback if the source is unavailable)
export default function Logo({ light = false, size = "md" }) {
  const [failed, setFailed] = useState(false);
  const h = size === "lg" ? "h-14" : "h-11";

  if (failed) {
    const box = size === "lg" ? "h-14 w-14 text-2xl" : "h-11 w-11 text-xl";
    const word = size === "lg" ? "text-2xl" : "text-lg";
    const textColor = light ? "text-white" : "text-[#16323f]";
    return (
      <Link to="/" className="flex items-center gap-2 select-none">
        <span className={`${box} grid place-items-center rounded-[3px] bg-[#16323f] font-display font-semibold text-white leading-none`}>
          <span className="flex items-baseline">
            <span>N</span>
            <span className="text-[#ec008c]">S</span>
          </span>
        </span>
        <span className={`font-display ${word} leading-[0.95] ${textColor}`}>
          <span className="block font-semibold tracking-wide">NEW</span>
          <span className="block font-semibold tracking-wide">SPACE</span>
        </span>
      </Link>
    );
  }

  return (
    <Link to="/" className="flex items-center select-none">
      <img
        src={LOGO_URL}
        onError={() => setFailed(true)}
        alt="New Space"
        className={`${h} w-auto object-contain`}
      />
    </Link>
  );
}
